import React from "react";
import { parameterName } from "../../../../parts/other-exercise/CustomParametersSets";

const {
  PARAMETER_OPTIONS: { FREEFORM },
} = require("../../../../constants");

const WeekTitlesComponent = ({ exercise, intensityMeasure, isRiR }) => (
  <div className="week-titles">
    {exercise.parameters ? (
      exercise.parameters.map((parameter, i) => (
        <span
          key={`${parameter}-${i}`}
          className={parameter === FREEFORM ? "invisible" : ""}
        >
          {parameterName(parameter, isRiR)}
        </span>
      ))
    ) : (
      <>
        <span>Sets</span>
        <span>Reps</span>
        <span>{intensityMeasure}</span>
        <span>Load</span>
        {exercise.type !== "assistant" && <span>Intensity</span>}
      </>
    )}
    <span>Status</span>
  </div>
);

export default WeekTitlesComponent;
